<woa-modal-page-layout [title]="title()">
    <woa-form (onSubmit)="confirmName()">
        <woa-text-field [(ngModel)]="name" name="name" [label]="'woa.label.entry.waiterName'"
                        [placeholder]="'woa.label.entry.waiterNamePlaceholder'"
                        required [maxlength]="'50'"></woa-text-field>
    </woa-form>
    <woa-button woa-page-footer-control [label]="buttonLabel()"
                (onActivate)="form().submit()"></woa-button>
</woa-modal-page-layout>
